module.exports = __webpack_public_path__ + "img/tree_4_4.26dd0a39.png";